export enum EObjectType {
  Flat = 'flat',
  Room = 'room',
  House = 'house',
  Bed = 'bed',
}

export enum ERoomsCount {
  Studio = 'studio',
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Five = 'five',
  Six_and_more = 'six_and_more',
}

export enum EPriceType {
  Free = 'free',
  Symbolic = 'symbolic',
  Utility_bill = 'utility_bill',
}

export enum EMoscow {
  Moscow = '_Moscow_',
  MoscowRegion = '_MoscowRegion_',
  Other = '_Other_',
}

export interface IDobroForm {
  objectType: EObjectType | null;
  moscow: EMoscow | null;
  location: string;
  address: string;
  guestsCount: number | null;
  roomsCount: ERoomsCount | null;
  area: number | null;
  floor: number | null;
  bedsCount: number | null;
  facilities: string[];
  bedsDescription: string;
  availablePeriod: string;
  otherWishes: string;
  phone: string;
  additionalPhone: string;
  name: string;
  offerSigned: boolean;
  priceType: EPriceType | null;
  priceDescription: string;
  availableFor: string[];
  telegram: string;
}

export interface IDobroFormErrors {
  hasErrors: boolean;
  invalidFields: Array<keyof IDobroForm>;
  guestsCountErrorMessage: string | null;
  areaErrorMessage: string | null;
  floorErrorMessage: string | null;
  bedsCountErrorMessage: string | null;
  phoneErrorMessage: string | null;
  additionalPhoneErrorMessage: string | null;
}
